import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getTenantId } from '@/mixins/Helpers'
import { BASE_URL } from '@/services/api'
import Ls from './services/ls'

window.Pusher = Pusher;

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;
const reverbHost = import.meta.env.VITE_REVERB_HOST;

if (reverbKey && reverbHost) {
    try {
        const forceTLS = (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https'

        window.Echo = new Echo({
            broadcaster: 'reverb',
            key: reverbKey,
            wsHost: getTenantId() + reverbHost,
            wsPort: parseInt(import.meta.env.VITE_REVERB_PORT) || 6001,
            wssPort: parseInt(import.meta.env.VITE_REVERB_PORT) || 6001,
            forceTLS,
            enabledTransports: ['ws', 'wss'],
            authEndpoint: `${BASE_URL}/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: 'Bearer ' + Ls.get('auth.token'),
                    Accept: 'application/json',
                    'X-Tenant': getTenantId() ? getTenantId().replace(/\.$/, '') : '',
                },
            },
        });
    } catch (e) {
        window.Echo = null;
    }
} else {
    window.Echo = null;
}
